import { Modal, ModalBody, ModalFooter, ROLE, SIZE } from 'baseui/modal';
import Separator from 'components/common/separator';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import { DialogCommonStyles } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  onClose: () => void;
  type: 'receivable' | 'suspend' | 'limited';
}

export default function NoticeSuspendDialog(props: Props) {
  const { t } = useTranslation();

  const message = React.useMemo(() => {
    switch (props.type) {
      case 'receivable':
        return t('common:customer_due_receivable_message');
      case 'suspend':
        return t('common:customer_suspend_message');
      case 'limited':
        return t('common:customer_limited_transaction_message');
    }
  }, [props.type, t]);

  return (
    <Modal
      closeable={false}
      isOpen
      animate
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      onClose={props.onClose}
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={DialogCommonStyles}
    >
      {/* <ModalHeader /> */}
      <ModalBody>
        <Separator gap={20} />
        <Text variant="LabelMedium">{message}</Text>
      </ModalBody>
      <ModalFooter $style={{ display: 'flex', justifyContent: 'end' }}>
        <Button buttonType="tertiary" onClick={props.onClose}>
          {t('common:close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
